
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adstod/[slug]",
      function () {
        return require("private-next-pages/adstod/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adstod/[slug]"])
      });
    }
  